import React, { useState } from 'react';
import ABCDExercise from './ABCDExercise';
import './ABCDExerciseBoard.css';

const ABCD_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #8a2be2 0%, #a855f7 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 512 512" fill="white">
      <g>
        <path d="m0 241h241v-241h-231c-5.523 0-10 4.477-10 10zm55.88-61.75 48.13-126.37c.05-.12.09-.24.14-.35 6.058-14.817 27.053-14.816 33.13-.03.05.14.11.27.16.41l47.7 126.39c2.92 7.75-.99 16.4-8.74 19.33-7.98 2.964-16.474-1.157-19.33-8.74-2.588-6.858-.887-2.353-8.22-21.77h-56.62c-7.376 19.343-5.698 14.938-8.31 21.81-2.95 7.74-11.62 11.63-19.36 8.68s-11.63-11.61-8.68-19.36z"/>
        <path d="m271 0v241h241v-231c0-5.523-4.477-10-10-10zm125.12 199.44c-8.977 0-43.74.15-43.74.15-8.285 0-15-6.726-15-15v-128.18c0-8.29 6.72-15 15-15h37.23c35.677 0 56.764 40.06 36.84 69.43 11.66 9.07 19.17 23.22 19.17 39.1 0 27.29-22.21 49.5-49.5 49.5z"/>
        <path d="m10 512h231v-241h-241v231c0 5.523 4.477 10 10 10zm166.59-186.08c6.86 4.64 8.67 13.97 4.03 20.83-4.649 6.873-13.946 8.668-20.83 4.03-32.257-21.796-76.52 1.283-76.52 40.72 0 42.363 49.706 62.049 74.29 40.16 3.899-3.476 6.501-8.785 14.48-9.14 12.923-.641 20.621 14.579 12.18 24.62-40.696 48.713-130.95 17.344-130.95-55.64 0-63.402 71.16-100.805 123.32-65.58z"/>
        <path d="m271 512h231c5.523 0 10-4.477 10-10v-231h-241zm77.77-197.7h35.23c39.02 0 65.23 31.03 65.23 77.2 0 20.23-5.81 38.96-16.38 52.74-11.69 15.26-28.58 23.85-47.56 24.18-8.983.152-35.255.28-36.27.28-7.893 0-14.494-6.152-14.97-14.09v-.05c-.02-.27-.03-.54-.03-.81 0 0-.25-71.621-.25-124.32 0-8.674 6.948-15.13 15-15.13z"/>
        <path d="m120.67 93.43-17.02 44.69h33.88z"/>
        <path d="m384.77 438.42c23.81-.41 34.46-23.86 34.46-46.92 0-22.82-9.25-47.2-35.23-47.2h-20.2c.084 64.107.067 64.113.17 94.32 7.52-.05 16.03-.11 20.8-.2z"/>
        <path d="m404.11 85.9c0-7.99-6.5-14.49-14.5-14.49h-22.23v29.02.04c2.785-.009 14.439-.07 22.23-.07 8 0 14.5-6.5 14.5-14.5z"/>
        <path d="m396.12 130.43c-10.073 0-17.998 0-28.74 0v39.1c10.48-.04 23.49-.09 28.74-.09 10.75 0 19.5-8.75 19.5-19.5 0-10.76-8.75-19.51-19.5-19.51z"/>
      </g>
    </svg>
  </span>
);

const ABCDExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { questions, title, level, passage } = exerciseData;

  if (!questions || !Array.isArray(questions)) {
    return (
      <div className="abcd-board-error">
        <p>Error: Invalid ABCD exercise data</p>
      </div>
    );
  }

  return (
    <div className="abcd-exercise-board">
      {!isExpanded ? (
        <div
          className={`abcd-preview unified-exercise-preview${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {ABCD_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'ABCD Exercise'}</div>
            <div className="unified-preview-meta">
              {questions.length} questions · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="abcd-expanded">
          <ABCDExercise
            questions={questions}
            title={title}
            level={level}
            passage={passage}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default ABCDExerciseBoard; 